import { Controller } from 'stimulus';
import dataLayer from '../helpers/dataLayer';

class WishlistController extends Controller {
  onToggle(e) {
    e.preventDefault();
    e.stopPropagation();

    const isLoggedIn = this.element.dataset.wishlistLoggedin === '1';

    if (!isLoggedIn) {
      this.redirectToLogin();
      return;
    }

    const isAdd = !this.element.classList.contains('is-added');
    const productVariantId = parseInt(this.data.get('productVariantId'), 10);

    this.updateHeaderCount(isAdd ? 1 : -1);
    this.updateButtonStyle(isAdd);
    this.updateButtonDisabledState(true);

    if (isAdd) {
      const gtmProduct = this.data.get('gtm-product');

      if (gtmProduct && gtmProduct.indexOf('{') === 0) {
        dataLayer.addProductToWishlist(JSON.parse(gtmProduct));
      }
    }

    (isAdd ? this.wishlistAdd : this.wishlistRemove)(productVariantId)
      .then(() => {
        this.updateButtonDisabledState(false);
      })
      .catch(() => {
        this.updateButtonStyle(false);
        this.updateButtonDisabledState(false);
      });
  }

  updateButtonDisabledState(disabled) {
    if (disabled) {
      this.element.setAttribute('disabled', 'disabled');
      return;
    }

    this.element.removeAttribute('disabled');
  }

  updateButtonStyle(isAdd) {
    const isBtnClass = this.element.classList.contains('btn');

    this.element.classList[isAdd ? 'add' : 'remove']('is-added');

    if (isBtnClass) {
      this.element.classList[isAdd ? 'add' : 'remove']('btn--positive');
    }
  }

  // eslint-disable-next-line class-methods-use-this
  updateHeaderCount(increment) {
    const headerCount = document.querySelector('.js-header-wishlist-items');

    if (!headerCount) {
      return;
    }

    headerCount.classList.remove('d-none');

    const count = parseInt(headerCount.textContent, 10);

    headerCount.textContent = count + increment;
  }

  // eslint-disable-next-line class-methods-use-this
  redirectToLogin() {
    const modal = document.getElementById('loginModal');

    if (modal) {
      $(modal).modal('show');
      return;
    }

    window.location.href = '/login';
  }

  // eslint-disable-next-line class-methods-use-this
  wishlistAdd(productVariantId) {
    return $.ajax({
      url: '/api/wishlist',
      method: 'POST',
      data: {
        _method: 'POST',
        product_variant_id: productVariantId,
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  wishlistRemove(productVariantId) {
    return $.ajax({
      url: '/api/wishlist',
      method: 'POST',
      data: {
        _method: 'DELETE',
        product_variant_id: productVariantId,
      },
    });
  }
}

WishlistController.targets = [
  //
];

export default WishlistController;
